import React, { useEffect } from "react";
import "./Legal.css";

const sections = [
  {
    number: "01",
    title: "Agreement to Terms",
    content: [
      "By accessing our website or engaging ASCENCIO Group for services, you agree to be bound by these Terms of Service. If you do not agree, please do not use our website or services.",
      "These terms apply to all visitors, clients, and anyone who accesses or uses our services.",
    ],
  },
  {
    number: "02",
    title: "Our Services",
    content: [
      "ASCENCIO Group provides digital marketing services to Aesthetic Clinics, including but not limited to lead generation, social media management, marketing automation, and website design.",
      "The specific scope, deliverables, timelines, and fees for each engagement are agreed upon in a separate Service Agreement or Statement of Work signed by both parties.",
    ],
  },
  {
    number: "03",
    title: "Client Responsibilities",
    content: ["As a client, you agree to:"],
    list: [
      "Provide accurate and complete information required to deliver our services",
      "Ensure all content and materials provided to us are legally owned or licensed",
      "Comply with all applicable laws and regulations including ASA and HPRA advertising standards",
      "Respond to communications in a timely manner to avoid project delays",
      "Not use our services for any unlawful or prohibited purpose",
    ],
  },
  {
    number: "04",
    title: "Payment Terms",
    content: [
      "Payment terms are outlined in your individual Service Agreement. Unless otherwise agreed:",
    ],
    list: [
      "Invoices are due within 14 days of issue",
      "Late payments may incur interest at 8% above the Bank of England base rate",
      "We reserve the right to pause services for overdue accounts",
      "All fees are exclusive of VAT where applicable",
    ],
  },
  {
    number: "05",
    title: "Intellectual Property",
    content: [
      "Upon full payment, clients own all final deliverables created specifically for them. ASCENCIO Group retains ownership of all underlying tools, frameworks, methodologies, and pre-existing intellectual property used to deliver services.",
      "We reserve the right to reference client work in our portfolio unless otherwise agreed in writing.",
    ],
  },
  {
    number: "06",
    title: "Confidentiality",
    content: [
      "Both parties agree to keep confidential any proprietary information shared during the course of the engagement. This includes business strategies, patient data, financial information, and any materials marked as confidential.",
      "This obligation survives the termination of any service agreement.",
    ],
  },
  {
    number: "07",
    title: "Limitation of Liability",
    content: [
      "To the maximum extent permitted by law, ASCENCIO Group shall not be liable for any indirect, incidental, or consequential damages arising from the use of our services.",
      "Our total liability in any matter shall not exceed the total fees paid by the client in the three months preceding the claim.",
    ],
    highlight: {
      text: "Important:",
      note: "Marketing results depend on many factors outside our control. We do not guarantee specific revenue outcomes, although we are committed to delivering the highest quality service.",
    },
  },
  {
    number: "08",
    title: "Termination",
    content: [
      "Either party may terminate a service agreement with 30 days written notice. Upon termination, all outstanding fees become immediately due. We will deliver all completed work and assets to the client upon receipt of final payment.",
    ],
  },
  {
    number: "09",
    title: "Governing Law",
    content: [
      "These Terms of Service are governed by and construed in accordance with the laws of England and Wales. Any disputes shall be subject to the exclusive jurisdiction of the courts of England and Wales.",
    ],
  },
  {
    number: "10",
    title: "Contact Us",
    content: [
      "If you have any questions about these Terms of Service, please contact us:",
    ],
    highlight: {
      text: "Email: hello@ascencio.com | Address: London, UK",
      note: "We aim to respond to all enquiries within 2 business days.",
    },
  },
];

const TermsOfService = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-page">
      <div className="legal-page__container">
        <div className="legal-page__badge">Legal</div>
        <h1 className="legal-page__title">Terms of Service</h1>
        <p className="legal-page__updated">Last updated: February 2025</p>

        <div className="legal-page__content">
          {sections.map((section, index) => (
            <div key={index} className="legal-section">
              <div className="legal-section__number">{section.number}</div>
              <h2 className="legal-section__title">{section.title}</h2>
              {section.content.map((text, i) => (
                <p key={i} className="legal-section__text">
                  {text}
                </p>
              ))}
              {section.list && (
                <ul className="legal-section__list">
                  {section.list.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              )}
              {section.highlight && (
                <div className="legal-section__highlight">
                  <p>
                    <strong>{section.highlight.text}</strong>{" "}
                    {section.highlight.note}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
